const topologies = {
	BUCK: '降压',
    BOOST: '升压',
    FLYBACK: '固定频率反激式',
    QR_FLYBACK: '准谐振反激式',
    LDO: 'LDO',
    CHARGE_PUMP: '电荷泵',
    INVERTING_BUCK_BOOST: '反相降压-升压'
};

export default topologies;
